<template>
  <div class="option">

    <div :class="{'search-box': true, 'active-search': searchInputState}">
      <div class="icon-box" @click="onSearch">
        <font-awesome-icon :icon="['fas', 'search']" class="icon" />
      </div>
      <input type="text" class="search-input" @keypress.enter="onSearch" v-model="query" @focus="showHints" @blur.prevent="hideHints">
      <div class="label-box" @click="onSearch">
        Search
      </div>
      <div class="close-box" @click="onCloseSearch">
        <font-awesome-icon :icon="['fas', 'times']" class="icon" />
      </div>
    </div>

    <div class="hints" v-if="searchInputState && hints">
      <div class="title">Try to search:</div>
      <div class="hints-box">
        <div class="hint" @click="addHint">travel</div>
        <div class="hint" @click="addHint">food</div>
        <div class="hint" @click="addHint">work</div>
        <div class="hint" @click="addHint">social</div>
        <div class="hint" @click="addHint">culture</div>
        <div class="hint" @click="addHint">shop</div>
        <div class="hint" @click="addHint">health</div>
        <div class="hint" @click="addHint">business</div>
        <div class="hint" @click="addHint">kids</div>
        <div class="hint" @click="addHint">youth</div>
        <div class="hint" @click="addHint">teens</div>
        <div class="hint" @click="addHint">adults</div>
        <div class="hint" @click="addHint">A1</div>
        <div class="hint" @click="addHint">A2</div>
        <div class="hint" @click="addHint">B1</div>
        <div class="hint" @click="addHint">B2</div>
        <div class="hint" @click="addHint">C1</div>
        <div class="hint" @click="addHint">FCE</div>
      </div>
    </div>

  </div>
</template>

<script>
import alert from '@/lib/alert'

export default {
  name: 'Search',
  data() {
    return {
      query: '',
      hints: false
    }
  },
  props: {
    searchInputState: Boolean
  },
  methods: {
    onSearch() {
      if(!this.searchInputState) {
        this.$emit('openSearchInput');
        if(window.innerWidth > 875) {
          setTimeout(() => {
            document.querySelector('.search-input').focus();
          }, 10);
        } else {
          setTimeout(() => {
            document.querySelector('.mobile-search-box').querySelector('input').focus();
          }, 10);
        }
      } else {
        if(this.query.trim() == '') {
          console.log('Empty Query');
          alert.showWarning('Empty Query');
        } else {
          this.$emit('searchDialog', this.query)
        }
      }
    },
    onCloseSearch() {
      this.$emit('closeSearchInput');
      this.$emit('closeSearch');
      this.query = '';
    },
    addHint(hint) {
      let text = hint.target.innerText;
      this.query = text;
      this.onSearch();
    },
    showHints() {
      this.hints = true;
    },
    hideHints() {
      setTimeout(() => {
        this.hints = false;
      }, 150)
    }
  }
}
</script>

<style lang="scss" scoped>
.option {
  width: auto;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  position: relative;
}

.search-box {
  width: auto;
  height: 2.5rem;
  display: flex;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  transition: 0.3s;

  input {
    width: 15rem;
    background-color: #12a798;
    border: none;
    outline: none;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    color: white;
    font-size: 1rem;
    display: none;

    &::placeholder {
      color: rgba(255, 255, 255, 0.575);
    }

    &:focus {
      border: 1px solid white;
    }
  }

  .icon-box {
    width: 2.5rem;
    height: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;

    .icon {
      color: white;
      font-size: 1.3rem;
    }
  }

  .close-box {
    width: 2.5rem;
    height: 2.5rem;
    display: none;
    justify-content: center;
    align-items: center;
    background-color: #12a798;
    border-top-right-radius: 0.2rem;
    border-bottom-right-radius: 0.2rem;
    transition: 0.3s;
    &:hover {
      background-color: #139b8d;
      cursor: pointer;
    }

    .icon {
      color: white;
      font-size: 1.5rem;
    }
  }

  .label-box {
    width: auto;
    height: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 0.2rem;
    padding-right: 0.5rem;
    color: white;
    font-size: 1.3rem;
    font-weight: bold;

    @media (max-width: 875px) {
      display: none;
    }
  }

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
}

.active-search {
  @media (max-width: 875px) {
    display: none;
  }
  input {
    display: flex;
  }
  .close-box {
    display: flex;
  }
  &:hover {
    cursor: default;
    opacity: 1;
  }
  .label-box {
    display: none;
  }
  .icon-box {
    border-top-left-radius: 0.2rem;
    border-bottom-left-radius: 0.2rem;
    background-color: #12a798;
    transition: 0.3s;
    &:hover {
      background-color: #139b8d;
      cursor: pointer;
    }
  }
}

.hints {
  position: absolute;
  width: 20rem;
  min-height: 8rem;
  background-color: #12a798;
  border: 1px solid white;
  top: 4rem;
  border-radius: 0.2rem;
  @media (max-width: 875px) {
    display: none;
  }
  display: flex;
  flex-direction: column;
  padding-bottom: 0.5rem;

  .title {
    width: 100%;
    height: 2.3rem;
    display: flex;
    align-items: flex-end;
    color: white;
    padding-left: 0.8rem;
    padding-bottom: 0.2rem;
    font-size: 1.2rem;
  }

  .hints-box {
    width: 100%;
    height: auto;
    padding-left: 0.8rem;
    padding-right: 0.8rem;
    padding-top: 0.3rem;
    padding-bottom: 0.3rem;
    display: flex;
    flex-wrap: wrap;
  }

  .hint {
    width: auto;
    height: auto;
    padding-top: 0.1rem;
    padding-bottom: 0.1rem;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
    border-radius: 0.1rem;
    margin-left: 0.5rem;
    margin-top: 0.5rem;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}
</style>